import React from "react";
import { ReactComponent as BatteryIcon } from "../images/battery.svg";
import { ReactComponent as JumpStartIcon } from "../images/jumpstart.svg";
import { ReactComponent as VanIcon } from "../images/van.svg";
import { ReactComponent as CheckIcon } from "../images/diagnostic.svg";
import "../styles/services.css";

export default function ServicesCards() {
  const services = [
    {
      icon: <BatteryIcon className="service-icon" />,
      title: "Helyszíni akkumulátor csere",
      desc: "Új akkumulátor beszerelése azonnal, a helyszínen.",
    },
    {
      icon: <JumpStartIcon className="service-icon" />,
      title: "Autó bikázás",
      desc: "Lemerült akkumulátor esetén az autó beindítása biztonságosan.",
    },
    {
      icon: <VanIcon className="service-icon" />,
      title: "Személyautó, kisteherautó és furgon bikázása",
      desc: "Minden méretű jármű szakszerű indítása a helyszínen.",
    },
    {
      icon: <CheckIcon className="service-icon" />,
      title: "Akkumulátor állapotfelmérés",
      desc: "Akkumulátor diagnosztika és személyre szabott tanácsadás.",
    },
  ];

  return (
    <section id="services" className="py-5">
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="fw-bold">Szolgáltatásaink</h2>
          <div className="double-divider my-3"></div>
          <p className="lead text-muted">
            Gyors, megbízható és szakszerű segítség, amikor a legnagyobb szükség
            van ránk.
          </p>
        </div>

        <div className="row g-4">
          {services.map((service, i) => (
            <div className="col-12 col-md-6 col-lg-3" key={i}>
              <div className="service-card text-center p-4 h-100">
                <div className="icon-wrapper mb-3">{service.icon}</div>
                <h5 className="fw-semibold mb-2">{service.title}</h5>
                <p className="text-muted mb-0">{service.desc}</p>
              </div>
            </div>
          ))}
        </div>
        <p className="lead text-muted pt-4">
          Szolgáltatásunk kifejezetten Pest megyére koncentrál, így Budapesttől
          egészen a kisebb településekig gyorsan kiérünk.
        </p>
      </div>
    </section>
  );
}
